module.exports = __webpack_public_path__ + "01555d25092b213d2ea3a982123722c9.ttf";